module.exports = __webpack_public_path__ + "assets/img/Kitome-Blog-w720.e06b63f6.webp";